import { memo, MouseEventHandler } from 'react';

import { ReactComponent as AvatarIcon } from 'assets/images/avatar.svg';

import styles from './styles.module.scss';

type Props = {
  email: string;
  onLogout: MouseEventHandler<HTMLButtonElement>;
};

export const Footer: React.FC<Props> = memo(function Footer({ email, onLogout }) {
  return (
    <div className={styles.container}>
      <AvatarIcon />
      <div>
        <p>{email}</p>
        <button type="button" onClick={onLogout}>
          Log out
        </button>
      </div>
    </div>
  );
});
